module.exports = __webpack_public_path__ + "img/nfts-page-bg.5cb66bb8.png";